"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var requireCoursesFromMap_1 = require("../utils/requireCoursesFromMap");
var combineVerifications_1 = require("../utils/combineVerifications");
var courseOptionsFromCourseMap_1 = require("../utils/courseOptionsFromCourseMap");
exports.default = function (allCourses, courseMap) {
    var validations = {
        mathematics: {
            mathematicsBase: requireCoursesFromMap_1.requireAllCoursesFromMap(allCourses, mathRequirements.baseRequirements, 'math-base-requirements'),
            mathematicsExtra: requireCoursesFromMap_1.requireSomeCoursesFromMap(allCourses, mathRequirements.twoAdditionalCreditsFrom, 'math-extra-requirements', 2),
            optionsBase: courseOptionsFromCourseMap_1.default(courseMap, mathRequirements.baseRequirements, 1, 'mathematics-options'),
            optionsExtra: courseOptionsFromCourseMap_1.default(courseMap, mathRequirements.twoAdditionalCreditsFrom, 2, 'mathematics-options'),
            validate: function (courses) {
                if (courses === void 0) { courses = allCourses; }
                var mathematicsBaseResult = validations.mathematics.mathematicsBase(courses);
                var mathematicsExtraResult = validations.mathematics.mathematicsExtra(mathematicsBaseResult.coursesNotConsumed);
                return combineVerifications_1.default([mathematicsBaseResult, mathematicsExtraResult], mathematicsExtraResult.coursesNotConsumed);
            }
        },
        computerScience: {
            validate: requireCoursesFromMap_1.requireSomeCoursesFromMap(allCourses, computerScienceRequirements.baseRequirements, 'computer-science-requirements', 4),
            options: courseOptionsFromCourseMap_1.default(courseMap, computerScienceRequirements.baseRequirements, 4, 'computer-science-options')
        },
        science: {
            scienceBase: requireCoursesFromMap_1.requireAllCoursesFromMap(allCourses, scienceRequirements.baseRequirements, 'science-base-requirements'),
            scienceExtra: requireCoursesFromMap_1.requireSomeCoursesFromMap(allCourses, scienceRequirements.twoAdditionalCreditsFrom, 'science-extra-requirements', 2),
            optionsBase: courseOptionsFromCourseMap_1.default(courseMap, scienceRequirements.baseRequirements, 2, 'science-options'),
            optionsExtra: courseOptionsFromCourseMap_1.default(courseMap, scienceRequirements.twoAdditionalCreditsFrom, 2, 'science-options'),
            validate: function (courses) {
                if (courses === void 0) { courses = allCourses; }
                var scienceBaseResult = validations.science.scienceBase(courses);
                var scienceExtraResult = validations.science.scienceExtra(scienceBaseResult.coursesNotConsumed);
                return combineVerifications_1.default([scienceBaseResult, scienceExtraResult], scienceExtraResult.coursesNotConsumed);
            }
        },
        combinationOfTwo: {
            comboBase: requireCoursesFromMap_1.requireAllCoursesFromMap(allCourses, combinationOfTwoRequirements.baseRequirements, 'combination-of-two-base'),
            comboExtra: requireCoursesFromMap_1.requireSomeCoursesFromMap(allCourses, combinationOfTwoRequirements.oneExtraCreditFrom, 'combination-of-two-extra', 1),
            optionBase: courseOptionsFromCourseMap_1.default(courseMap, combinationOfTwoRequirements.baseRequirements, 3, 'combo-base-options'),
            optionExtra: courseOptionsFromCourseMap_1.default(courseMap, combinationOfTwoRequirements.oneExtraCreditFrom, 3, 'combo-extra-options'),
            validate: function (courses) {
                if (courses === void 0) { courses = allCourses; }
                var baseResult = validations.combinationOfTwo.comboBase(courses);
                var extraResult = validations.combinationOfTwo.comboExtra(baseResult.coursesNotConsumed);
                return combineVerifications_1.default([baseResult, extraResult], extraResult.coursesNotConsumed);
            }
        }
    };
    return validations;
};
var mathRequirements = {
    baseRequirements: {
        'algebra ii': 1,
    },
    twoAdditionalCreditsFrom: {
        precalculus: 1,
        'ap calculus ab': 1,
        'ap calculus bc': 1,
        //'indep study in math': 1, //deletion edit 2024
        'advanced quant reasoning': 1,
        'independ study math': 1,
        'discrete math for prblm solvng': 1,
        'algebraic reasoning': 1,
        'ap statistics': 1,
        'ap computer science a': 1,
        'engineering mathematics': 1,
        'statistics and business decision making': 1,
        'mathematics for medical professionals': 1,
        'discrete math for comp science': 1,
        /* new courses added 2018-06-26 */
        "colge prep course mathematics": 1,
        "fundamentals of comp science": 1,
        "ib computer science, highr lvl": 1,
        "ib computer science, std level": 1,
        "ib further mthematics high lvl": 1,
        "ib mathematical studies stan.": 1,
        "ib mathematics higher level": 1,
        "ib mathematics standard level": 1,
        "linear algebra": 0.5,
        "multivariable calculus": 1,
        "number theory": 0.5,
        "statistics": 1,
        "strategic learn f/hs math": 1
    }
};
var computerScienceRequirements = {
    baseRequirements: {
        'fundamentals of computer science': 1,
        'computer science i': 1,
        'computer science ii': 1,
        'computer science iii': 1,
        'digital forensics': 1,
        'discrete math for comp science': 1,
        'game programming and design': 1,
        'mobile application development': 1,
        'robotics programming & design': 1,
        'independent studies in technology applications': 1,
        'ap computer science a': 1,
        'ap computer science principles': 1,
        'ib computer science, standard level': 1,
        'ib computer science, higher level': 1,
        /* new courses added 2018-06-26 */
        "fundamentals of comp science": 1,
        "ib computer science, highr lvl": 1,
        "ib computer science, std level": 1
    }
};
var scienceRequirements = {
    baseRequirements: {
        physics: 1,
        chemistry: 1,
        /* new courses added 2018-06-26 */
        "ap physics 1: algebra based": 1,
        "ap physics 2: algebra based": 1,
        "ap physics c": 1,
        "ap physics c: electr&magnetism": 1,
        "ap physics c: mechanics": 1,
        "electricity and magnetism": 0.5,
        "ib chemistry higher level": 2,
        "ib chemistry standard level": 2,
        "ib physics higher level": 2,
        "ib physics standard level": 2,
        "modern physics": 1,
        "organic chemistry": 1
    },
    twoAdditionalCreditsFrom: {
        'aquatic science': 1,
        astronomy: 1,
        'earth and space science': 1,
        'environmental systems-envirsys': 1,
        'advanced animal science': 1,
        'adv plant & soil science': 1,
        'anatomy & physiology': 1,
        'medical microbiology': 1,
        pathophysiology: 1,
        'food science': 1,
        'forensic science': 1,
        biology: 1,
        biotechnology: 1,
        'principles of technology': 1,
        'scientific research & design': 1,
        'engineering design and problem solving': 1,
        'engineering science': 1,
        /* new courses added 2018-06-26 */
        "ib biology higher level": 2,
        "ib biology standard level": 2,
        "planet earth": 1,
        "scien research & design iii": 1,
        "science and tech": 1
    }
};
var combinationOfTwoRequirements = {
    baseRequirements: {
        'algebra ii': 1,
        chemistry: 1,
        physics: 1,
        /* new courses added 2018-06-26 */
        "ap physics 1: algebra based": 1,
        "ap physics 2: algebra based": 1,
        "ap physics c": 1,
        "ap physics c: electr&magnetism": 1,
        "ap physics c: mechanics": 1,
        "electricity and magnetism": 0.5,
        "ib chemistry higher level": 2,
        "ib chemistry standard level": 2,
        "ib physics higher level": 2,
        "ib physics standard level": 2,
        "modern physics": 1,
        "organic chemistry": 1
    },
    oneExtraCreditFrom: Object.assign({}, scienceRequirements.baseRequirements, scienceRequirements.twoAdditionalCreditsFrom, mathRequirements.baseRequirements, mathRequirements.twoAdditionalCreditsFrom, computerScienceRequirements.baseRequirements)
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../validation/build/pathValidations/stem/index.js
// module id = 455
// module chunks = 22